import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "components/NewSidebar/components/SidebarContent/components/SidebarItem";

import {ReactComponent as UserIcon} from "assets/img/user-square-contained.svg";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../../../../../SidebarContext";
import {SidebarFloatMenuContext} from "../../../../../../SidebarFloatMenu";
import {BottomDrawerContext} from "../../../../../../BottomDrawer";

function MyAccountItem(props) {
    const {currentMember} = useContext(SidebarContext);
    const {onClose} = useContext(SidebarFloatMenuContext);
    const {handleClose: onCloseMobile} = useContext(BottomDrawerContext);

    const {retailers} = currentMember;

    const profileUrl = retailers ? MarketplaceRoutes.RETAILER_ME(retailers[0]["id"]) : MarketplaceRoutes.ME

    return (
        <SidebarItem
            isTopLevel={true}
            icon={<UserIcon />}
            to={profileUrl}
            onClick={() => {
                onClose();
                onCloseMobile();
            }}
        >
            <FormattedMessage id='sidebar.profil.setting.menu.myAccount' />
        </SidebarItem>
    );
}

export default MyAccountItem;
